<template>
  <BaseOutline class="relative w-full max-w-lg flex">
    <div
      v-if="isCapybara"
      class="absolute top-[0.25rem] right-[4rem] flex -translate-y-full scale-x-[-1] opacity-10"
    >
      <img
        src="/images/capybara-dark-small.png"
        class="w-8 h-8"
        loading="lazy"
        :alt="$t('footer.capybaraAlt')"
      />
    </div>

    <div class="flex flex-col">
      <figure class="relative h-48">
        <img
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          sizes="100vw"
          :src="imageSrc"
          :alt="imageAlt"
          style="
            position: absolute;
            height: 100%;
            width: 100%;
            inset: 0px;
            object-fit: cover;
            color: transparent;
          "
        />
        <div class="absolute inset-0 bg-dark/5"></div>
      </figure>

      <div class="p-8 flex flex-col gap-2 bg-white">
        <h3 class="text-xl font-bold">
          <slot name="title" />
        </h3>
        <p class="text-gray-500 leading-relaxed">
          <slot name="description" />
        </p>
      </div>
    </div>
  </BaseOutline>
</template>

<script>
import BaseOutline from '@/components/Base/BaseOutline.vue'

export default {
  name: 'LandingHowItWorksCard',

  components: { BaseOutline },

  props: {
    isCapybara: { type: Boolean, default: false },
    imageSrc: { type: String, required: true },
    imageAlt: { type: String, required: true }
  }
}
</script>
